import React, { Component } from 'react';
import '../PersonRegist.css'

import intl from 'react-intl-universal';
import Select from 'react-select';
import { inject ,observer} from 'mobx-react';


//问题详情
@inject('store')
@observer
export default class QuestionList extends Component {
    constructor(props) {
        super();
        this.state = {
            data: { problem: '', solution: '', create_time: '' }

        };

    }

    componentDidMount() {
        document.title = '消息'

        var data = this.props.location.query;
        if (data) {
            let { problem, solution, create_time } = data;
            this.setState({ data: data })
            sessionStorage.setItem('wenti', JSON.stringify(data));
        } else {
            let str = sessionStorage.getItem('wenti')
            if (str && str.length > 0) {
                let strdata = JSON.parse(str)
                this.setState({ data: strdata })
            } else {
                window.location.href = this.props.store.rootUrl+ 'person/message/MessageList'
            }

        }

    }
    render() {
        let { data } = this.state

        return (
            <div className='flex-column-container' style={{ paddingLeft: 22, paddingRight: 22, flex: 1, marginTop: 20,background:"#fff" ,paddingBottom:20}}>

                <div className='flex-row-container' style={{ justifyContent: 'space-between' ,height:40,alignItems:'center'}}>
                    <p>故障保修提醒</p>
                    <p>{data.create_time.split('T')[0]}</p>
                </div>
                <div style={{ height: 2, backgroundColor: '#F4F4F4', width: '100%',  }}></div>
                <p style={{marginTop:10}}>{'问题:' + data.problem}</p>
                <p style={{marginTop:10}}>{'解决:'+data.solution}</p>

            </div>
        )
    }

    getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]); return null;
    }

}



// WEBPACK FOOTER //
// ./src/views/person/message/MessageDetail.js